import { render, staticRenderFns } from "./FormTextareaConfig.vue?vue&type=template&id=83de6228&scoped=true"
import script from "./FormTextareaConfig.vue?vue&type=script&lang=js"
export * from "./FormTextareaConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83de6228",
  null
  
)

export default component.exports